var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelVimeoSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 11,
  viewBox: "0 0 12 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.487 3.498s1.006-.795 1.34-.397c.336.397 1.615 5.194 2.042 6.078.372.776 1.4 1.802 2.528 1.07 1.126-.733 4.873-3.94 5.543-7.729.67-3.787-4.508-2.993-5.057.306 1.371-.825 2.103.335 1.402 1.65-.7 1.313-1.34 2.169-1.676 2.169-.334 0-.591-.879-.975-2.414-.396-1.588-.393-4.448-2.04-4.124C2.041.413 0 2.857 0 2.857z"
})));
export default SvgChannelVimeoSm;